import { DEFAULT_LANG, LANGUAGES } from "./languages";

// Public pages (home, game pages, legal pages) have an address per language:
// /games/mafia in English, /de/games/mafia in German, /ar/games/mafia in
// Arabic, so search engines can list each one. Rooms (/r/CODE) don't: they
// show whichever language each player picked.
const PREFIXED = LANGUAGES.filter((l) => l.code !== DEFAULT_LANG).map((l) => l.code);

export function langFromPath(pathname) {
  const m = /^\/([a-z]{2})(?=\/|$)/.exec(pathname || "");
  return m && PREFIXED.includes(m[1]) ? m[1] : null;
}

export const stripLang = (pathname) => (langFromPath(pathname) ? pathname.slice(3) || "/" : pathname);

export const withLang = (lang, path) => (lang === DEFAULT_LANG || !PREFIXED.includes(lang) ? path : `/${lang}${path === "/" ? "" : path}`);

export const isPublicPath = (path) => path === "/" || path.startsWith("/games/") || path === "/privacy" || path === "/terms";

export const LANG_PREFIXES = ["", ...PREFIXED.map((c) => `/${c}`)];
